import {
    GET_SCHEDULE_ENTRY_LIST_PROGRESS, GET_SCHEDULE_ENTRY_LIST_SUCCESS, GET_SCHEDULE_ENTRY_LIST_FAILURE,
    ADD_SCHEDULE_ENTRY_PROGRESS, ADD_SCHEDULE_ENTRY_SUCCESS, ADD_SCHEDULE_ENTRY_FAILURE,
    EDIT_DELETE_SCHEDULE_ENTRY_PROGRESS, EDIT_DELETE_SCHEDULE_ENTRY_SUCCESS, EDIT_DELETE_SCHEDULE_ENTRY_FAILURE,
    ////


    RESET_MESSAGE,

} from '../../types/actionTypes';

const initialState = {
    schedule_entry: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const schedule_entry_reducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_SCHEDULE_ENTRY_LIST_SUCCESS:
            return { ...state, schedule_entry: action.schedule_entry, loading: false };
        case GET_SCHEDULE_ENTRY_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_SCHEDULE_ENTRY_LIST_PROGRESS:
            return { ...state, loading: true, error: false };
        case ADD_SCHEDULE_ENTRY_PROGRESS:
            return { ...state, loading: true };
        case ADD_SCHEDULE_ENTRY_SUCCESS:
            return { ...state, schedule_entry: [...state.schedule_entry, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_SCHEDULE_ENTRY_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_SCHEDULE_ENTRY_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_SCHEDULE_ENTRY_SUCCESS:
            return {
                ...state,
                schedule_entry: state.schedule_entry.map((schedule_entry) =>
                    schedule_entry.id === action.payload.id ? action.payload : schedule_entry
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_SCHEDULE_ENTRY_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default schedule_entry_reducer;